import styled from "styled-components";

export const TransactionContend = styled.button((props) => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > img': {
        width: '12px',
        height: '12px',
        marginTop: '-10px',
        filter: 'invert(46%) sepia(83%) saturate(449%) hue-rotate(86deg) brightness(92%) contrast(89%)',
    },
}));
